import React from "react";
import PropTypes from "prop-types";
// MUI imports
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";

// Components
import Currency from "@components/currency";

function ItemActionButton({
  decreaseQuantity,
  increaseQuantity,
  addItem,
  item,
}) {
  return (
    <Box
      position="fixed"
      bottom={16}
      width="calc(100% - 32px)"
      p={2}
      zIndex={9999}
    >
      <Grid container spacing={3}>
        <Grid xs={5} item>
          <ButtonGroup
            variant="simple"
            aria-label="outlined primary button group"
            fullWidth
            sx={{ fontSize: 16 }}
          >
            <Button onClick={decreaseQuantity}>-</Button>
            <Button>{item.quantity}</Button>
            <Button onClick={increaseQuantity}>+</Button>
          </ButtonGroup>
        </Grid>
        <Grid item xs={7}>
          <Button variant="contained" fullWidth onClick={addItem}>
            Add <Currency value={item.totalPrice} />
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}

ItemActionButton.propTypes = {
  decreaseQuantity: PropTypes.func.isRequired,
  increaseQuantity: PropTypes.func.isRequired,
  addItem: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
};

export default ItemActionButton;
